import ExitButton from "../buttons/ExitButton";
import SendFormButton from "../buttons/SendFormButton";
import React from "react";
import styled from "styled-components";
import {BaseModal} from "./modalStyle";
import InputAdvancementFormik from "../inputs/InputAdvancementFormik";
import {useDispatch, useSelector} from "react-redux";
import {patchProject} from "../project/one-project/projectAction";
import {FunctionalModal} from "./FunctionalModal";
import {Formik} from "formik";
import {FormFormik} from "../inputs/InputStyle";

const AdvancementModal = ({setIsOpen}) => {

    const dispatch = useDispatch()

    const {id, advancement} = useSelector(state => state.project)

    const handleSubmit = async (data) => {
        await dispatch(patchProject(id, data));
        closeModal()
    }
    const closeModal = () => {
        setIsOpen(false)
    }

    return (
        <FunctionalModal
            setOpen={setIsOpen}
            component={
                <Modal
                    onSubmit={handleSubmit}>
                    <ExitButton
                        closeUpdate={closeModal}/>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            advancement: advancement,
                        }}
                        onSubmit={handleSubmit}
                    >
                        {({isValid, isSubmitting, values}) => (
                            <Form>
                                <label> Choisir un avancement </label>
                                <InputAdvancementFormik
                                    advancementSelection={values.advancement}
                                />
                                <SendFormButton
                                    state={isValid && !isSubmitting}
                                    actionName={"Enregistrer"}
                                />
                            </Form>
                        )}

                    </Formik>
                </Modal>
            }
        />
    )
}
const Modal = styled(BaseModal)`
  width: 20rem;
  height: fit-content;
  padding: 2rem;
  inset: 0;
  left: 0;
  right: 0;
  margin: auto;

  label {
    text-align: center;
  }

  .exit-btn {
    align-self: flex-end;
  }

  @media (min-width: 900px) {
    width: 40rem;
  }
`

const Form = styled(FormFormik)``

export default AdvancementModal